"use client";

import {
  FadeIn,
  HomeEyebrow,
  HomeHeading,
  HomeLead,
  HomeSection,
} from "~/components/siteglue/home/section-shell";

const LIVE_CHANNELS = [
  "Website chat",
  "Browser voice",
  "Phone",
  "Email",
  "Video",
  "SMS",
] as const;

export function SiteGlueHomeChannels() {
  return (
    <HomeSection id="every-channel" tone="white" className="py-14 sm:py-16">
      <FadeIn className="mx-auto max-w-2xl text-center">
        <HomeEyebrow>Channels</HomeEyebrow>
        <HomeHeading className="mx-auto">The conversations you can turn on today.</HomeHeading>
        <HomeLead className="mx-auto">
          SiteGlue Agent channels stay configurable after your free audit. Review results first,
          then choose the channels to activate.
        </HomeLead>
      </FadeIn>
      <ul className="mt-8 flex flex-wrap items-center justify-center gap-2">
        {LIVE_CHANNELS.map((label) => (
          <li
            key={label}
            className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm font-medium text-slate-800"
          >
            {label}
          </li>
        ))}
      </ul>
      <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-slate-500">
        WhatsApp and Messenger are not available yet.
      </p>
    </HomeSection>
  );
}
